import { DateTime } from 'luxon';
import type { ScaffolderTaskStatus } from '@backstage/plugin-scaffolder-common';

type StatusColorTone = 'success' | 'danger' | 'warning' | 'info' | 'secondary';

export const STATUS_COLORS: Record<ScaffolderTaskStatus, StatusColorTone> = {
  completed: 'success',
  failed: 'danger',
  processing: 'warning',
  open: 'info',
  cancelled: 'secondary',
  skipped: 'secondary',
};

export const STATUS_HEX_COLORS: Record<StatusColorTone, string> = {
  success: 'var(--bui-fg-success)',
  danger: 'var(--bui-fg-danger)',
  warning: 'var(--bui-fg-warning)',
  info: 'var(--bui-fg-info)',
  secondary: 'var(--bui-fg-secondary)',
};

export const formatDate = (isoDate: string): string => {
  return DateTime.fromISO(isoDate).toLocaleString(DateTime.DATETIME_MED);
};
